@if (buyOffer.id == 0 && !processCompleted && !processReview) {
  <div class="progress-tabs">
    @if (buyOffer.id == 0) {
      <div class="info mb-20">Please complete the following steps<br />to add your order(s).</div>
    }
    <span [className]="(step==1)?'current':''">1</span>
    <span [className]="(step==2)?'current':''">2</span>
    <span [className]="(step==3)?'current':''">3</span>
  </div>
}
@if (!processCompleted && !processReview) {
  <div class="form">
    <div class="card">
      <div class="left-margin"><span class="step-title">1</span></div>
      <div class="right-margin">
        <div class="right-margin-icon info-icon cursor-pointer" (click)="iIconPopup('Please, select one or multiple accounts of the same utility you want to include into your order.')"></div>
      </div>
      <div class="body" #body>
        <div>
          <h2>Select Utility Account(s)</h2>
          <div>
            @for (aData of accountsSelector; track aData; let p = $index) {
              @if (aData.group!='') {
                <div [class]="(p>0)?'mt-20':''" class="group">{{aData.group}}</div>
              }
              <div class="checkbox-list"><label><input type="checkbox" [checked]="ifItemSelected(aData.id)" (change)="selectItem(aData.id)" [disabled]="buyOffer.id==0 && step>1"> {{aData.text}}</label></div>
            }
          </div>
          @if (step==1 && this.showError && error!=null && error.length>0) {
            <div class="error-block">{{error}}</div>
          }
        </div>
      </div>
    </div>
    @if (step==1) {
      <div class="block-buttons under-card full-width">
        @if (step==1) {
          <button type="button" (click)="cancel()">Cancel</button>
        }
        <button type="button" [disabled]="selectedAccounts.length==0" (click)="finishStep1()">Next</button>
      </div>
    }
    @if (step>1 && step<=3) {
      <div class="card">
        <div class="left-margin"><span class="step-title">2</span></div>
        <div class="body">
          <h2>Select Target Price</h2>
          <div class="row">
            <input matInput
              [matDatepicker]="picker"
              [matDatepickerFilter]="boundInactiveDatesFilter"
              [formControl]="desiredStartTerm"
              (click)="picker.open()"
              readonly
              [disabled]="buyOffer.id==0 && step>2"
              placeholder="Service Start, 1st meter read on or after"
              [class]="getClassesForInput('desiredStartTerm', true, (desiredStartTerm==null || desiredStartTerm.value==null)?null:desiredStartTerm.value.toString())" />
              @if (getVisibilityForLabel((desiredStartTerm==null||desiredStartTerm.value==null)?null:desiredStartTerm.value.toString())) {
                <div class="placeholder">Service Start, 1st meter read on or after</div>
              }
              <mat-datepicker #picker startView="year" (yearSelected)="chosenYearHandler($event, desiredStartTerm)" (monthSelected)="chosenMonthHandler($event, desiredStartTerm, 'desiredStartTerm', picker); setDesiredTerm();"></mat-datepicker>
            </div>
            <div class="row">
              <input matInput
                [matDatepicker]="picker2"
                [matDatepickerFilter]="boundInactiveDatesEndFilter"
                [formControl]="desiredEndTerm"
                (click)="picker2.open()"
                readonly
                [disabled]="buyOffer.id==0 && step>2"
                placeholder="Service End, 1st meter read on or after"
                [class]="getClassesForInput('desiredEndTerm', true, (desiredEndTerm==null || desiredEndTerm.value==null)?null:desiredEndTerm.value.toString())" />
                @if (getVisibilityForLabel((desiredEndTerm==null||desiredEndTerm.value==null)?null:desiredEndTerm.value.toString())) {
                  <div class="placeholder">Service End, 1st meter read on or after</div>
                }
                <mat-datepicker #picker2 startView="year" (yearSelected)="chosenYearHandler($event, desiredEndTerm)" (monthSelected)="chosenMonthHandler($event, desiredEndTerm, 'desiredEndTerm', picker2); setDesiredTerm();"></mat-datepicker>
              </div>
              <div class="row">
                <input type="text"
                  [class]="getClassesForInput('desiredTerm', true, buyOffer.termPeriod+'')"
                  name="desiredTerm"
                  disabled="true"
                  [(ngModel)]="desiredTerm"
                  placeholder="Term" />
                  @if (getVisibilityForLabel((desiredTerm==null)?null:desiredTerm.toString())) {
                    <div class="placeholder">Term</div>
                  }
                </div>
                <select name="benchmarkType" [class]="getClassesForInput('benchmarkType', true, (benchmarkType==null)?null:benchmarkType)" [(ngModel)]="benchmarkType" (change)="changeChart();" [disabled]="buyOffer.id==0 && step>2">
                  @if (benchmarkType==null) {
                    <option [selected]="true" [value]="null" [disabled]="true">Target Price</option>
                  }
                  <option value="none">Custom Price</option>
                  @if (!checkIfUtilityEmpty()) {
                    <option value="utility">Utility average - no discount</option>
                  }
                  @if (!checkIfUtilityEmpty()) {
                    <option value="utility-10">Utility average - 10% discount applied</option>
                  }
                  @if (!checkIfUtilityEmpty()) {
                    <option value="utility-20">Utility average - 20% discount applied</option>
                  }
                  @if (!checkIfUtilityEmpty()) {
                    <option value="utility-30">Utility average - 30% discount applied</option>
                  }
                  @if (benchmarkContract!=null) {
                    <option value="contract">Previous price plan - no discount</option>
                  }
                  @if (benchmarkContract!=null) {
                    <option value="contract-10">Previous price plan - 10% discount applied</option>
                  }
                  @if (benchmarkContract!=null) {
                    <option value="contract-20">Previous price plan - 20% discount applied</option>
                  }
                  @if (benchmarkContract!=null) {
                    <option value="contract-30">Previous price plan - 30% discount applied</option>
                  }
                  @if (benchmarkOffer!=null) {
                    <option value="sell_offer">Seller offer - no discount</option>
                  }
                  @if (benchmarkOffer!=null) {
                    <option value="sell_offer-10">Seller offer - 10% discount applied</option>
                  }
                  @if (benchmarkOffer!=null) {
                    <option value="sell_offer-20">Seller offer - 20% discount applied</option>
                  }
                  @if (benchmarkOffer!=null) {
                    <option value="sell_offer-30">Seller offer - 30% discount applied</option>
                  }
                </select>
                @if (getVisibilityForLabel(benchmarkType)) {
                  <div class="placeholder">Target Price</div>
                }
                <div class="row highlighted-input">
                  @if (benchmarkType!=null) {
                    <input type="text"
                      [disabled]="(buyOffer.price==0 && step>2)"
                      class="placeholder highlighted"
                      name="desiredPrice"
                      [(ngModel)]="buyOffer.price"
                      (input)="resetError('desiredPrice'); setBenchmarkOfferCustom();"
                      (focus)="focusField('desiredPrice')"
                      (focusout)="focusOutField('desiredPrice')"
                      [placeholder]="'0.00000'"
                      [allowNegativeNumbers]="false"
                      mask="separator.5"
                      thousandSeparator=""
                      />
                  }
                  @if (benchmarkType!=null) {
                    <div class="placeholder">Target Price $/kWh</div>
                  }
                  <div class="right-margin-icon info-icon after-placeholder cursor-pointer" (click)="iIconPopup('For a custom target price move arrow up or down.');"></div>
                </div>
                <div class="mt-50 mb-20 trending-offers">
                  <kilowant-charts-place-order [view]="view"
                    [legend]="legend"
                    [legendTitle]="legendTitle"
                    [legendPosition]="legendPosition"
                    [showGridLines]="true"
                    [showDataLabel]="false"
                    [scheme]="colorScheme"
                    [showXAxisLabel]="showXAxisLabel"
                    [showYAxisLabel]="showYAxisLabel"
                    [xAxis]="xAxis"
                    [yAxis]="yAxis"
                    [xAxisLabel]="xAxisLabel"
                    [yAxisLabel]="yAxisLabel"
                    [groupPadding]="2"
                    [barPadding]="1"
                    [val]="buyOffer.price"
                    (changeVal)="changeVal($event)"
                    [results]="activeRates"
                    [utilityAverageRate]="ratesAveragePrice"
                    [latestUtility]="latestUtility"
                    [myContractRate]="(currentCost==null || currentCost.price==null || currentCost.price==0)?0:currentCost.price"
                    [myContractInFuture]="false"
                    [customMax]="customMax"
                    [utilityWarningDate]="latestUtilityDate"
                    [disabledButtons]="disabledButtons"
                    [datasetSelector]="countRates()>1"
                    [selectedDatasets]="selectedDatasets"
                    [tooltipDisabled]="true"
                    (datasetChanged)="changeDataset($event)"
                    [disabled]="(buyOffer.price==0 && step>2) || benchmarkType==null">
                  </kilowant-charts-place-order>
                </div>
                @if (step==2 && this.showError && error!=null && error.length>0) {
                  <div class="error-block">{{error}}</div>
                }
              </div>
            </div>
          }
          @if (step==2) {
            <div class="block-buttons under-card full-width">
              @if (step==2) {
                <button type="button" (click)="cancel()">Cancel</button>
              }
              @if (step==2) {
                <button type="button" (click)="step=1; showError=false;">Back</button>
              }
              @if (step==2) {
                <button type="button" (click)="finishStep2()">Next</button>
              }
            </div>
          }
          @if (step>2 && step<=3) {
            <div class="card">
              <div class="left-margin"><span class="step-title">3</span></div>
              <div class="body">
                <h2>Select Offer Duration</h2>
                <input matInput
                  [matDatepicker]="pickerGoodUntil"
                  [matDatepickerFilter]="boundInactiveDatesGoodUntilFilter"
                  [formControl]="durationOfOrder"
                  (click)="pickerGoodUntil.open()"
                  readonly
                  [disabled]="buyOffer.id==0 && step>3"
                  placeholder="Good Until"
                  [class]="getClassesForInput('durationOfOrder', true, (durationOfOrder==null || durationOfOrder.value==null)?null:durationOfOrder.value.toString())" />
                  @if (getVisibilityForLabel((durationOfOrder==null||durationOfOrder.value==null)?null:durationOfOrder.value.toString())) {
                    <div class="placeholder">Good Until</div>
                  }
                  <mat-datepicker #pickerGoodUntil></mat-datepicker>
                  @if (step==3 && this.showError && error!=null && error.length>0) {
                    <div class="error-block">{{error}}</div>
                  }
                </div>
              </div>
            }
          </div>
        }
        @if (step==3) {
          <div class="block-buttons under-card full-width">
            @if (step==3) {
              <button type="button" (click)="cancel()">Cancel</button>
            }
            @if (step==3) {
              <button type="button" (click)="step=2; showError=false;">Back</button>
            }
            @if (step==3) {
              <button type="button" (click)="finishStep3()">Next</button>
            }
          </div>
        }
        @if (step>3) {
          <div class="card">
            @if (processReview) {
              <div class="element-detail">
                <div class="f22"><b>Confirm Order</b></div>
                <p class="pt-4 text-color"><b>For the following utility account(s):</b></p>
                <div class="card-block-background view-closed">
                  @for (acc of selectedAccounts; track acc; let i = $index) {
                    <div>
                      <p class="text-color m-0 mb-1">{{accountIdent(acc)}}</p>
                    </div>
                  }
                </div>
                <p class="text-color"><b>You selected:</b></p>
                <div>
                  <p class="accountInfoBorder">Price</p>
                  <p class="subUniqueTitle">{{buyOffer.price | currency:'USD':'symbol':'1.5-5'}}/kWh</p>
                  <p class="accountInfoBorder">Service Start</p>
                  <p class="subUniqueTitle">1st meter read on or after {{buyOffer.termFrom | date:'shortDate'}}</p>
                  <p class="accountInfoBorder">Service End</p>
                  <p class="subUniqueTitle">1st meter read on or after {{getTermTo(buyOffer.termFrom, buyOffer.termPeriod) | date:'shortDate'}}</p>
                  <p class="accountInfoBorder">Offer Duration</p>
                  <p class="subUniqueTitle">Good until {{buyOffer.validDate | date:'shortDate'}}</p>
                </div>
              </div>
            }
            @if (processCompleted) {
              <div class="text-block">
                <br />
                <br />
                The order has been created.<br />
                <br />
              </div>
            }
          </div>
        }
        @if (step>3) {
          <div class="block-buttons under-card full-width">
            <button type="button" (click)="cancel()">Cancel</button>
            <button type="button" (click)="step=3; processReview = false; showError=false; error='';">Back</button>
            @if (buyOffer.id>0) {
              <button type="button" (click)="sendForm()">Update</button>
            }
            @if (buyOffer.id==0) {
              <button type="button" (click)="sendForm()">Confirm</button>
            }
          </div>
        }
        @if (processCompleted) {
          <div class="text-block">
            <br />
            <br />
            The order has been created.<br />
            <br />
          </div>
        }
